import { render, staticRenderFns } from "./orderManage.vue?vue&type=template&id=fb0d2c3a&scoped=true&"
import script from "./orderManage.vue?vue&type=script&lang=js&"
export * from "./orderManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb0d2c3a",
  null
  
)

export default component.exports